var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
import { inject } from "tsyringe";
import { GlobalConfig } from "../config";
import { makeImmutable } from "../core";
import { perRestaurant } from "../di";
import { LocalizationProvider } from "../locale";
import { HalvingPolicyAvailabilityService, Menu, NextOrderingTime, ParameterScopeProvider, ProductCardCreatorAvailabilityService, ProductCardCreatorPriceService, ProductInstancePreorderSettingsService, } from "../ordering";
import { OrderItemListTracking } from "./OrderItemListTracking";
import { PCrossSellingAddToCartBottomSheet } from "./PCrossSellingAddToCartBottomSheet";
import { PPrice } from "./PPrice";
import { PRestaurant } from "./PRestaurant";
import { LabelsService } from "../labels";
let PProductCardCreatorContext = class PProductCardCreatorContext {
    constructor(globalConfig, localizationProvider, productCardCreatorAvailabilityService, halvingPolicyAvailabilityService, productInstancePreorderSettingsService, labelsService, productCardCreatorPriceService, restaurant, menu, orderItemListTracking, nextOrderingTime, crossSellingAddToCartBottomSheet, parameterScopeProvider) {
        this.localizationProvider = localizationProvider;
        this.productCardCreatorAvailabilityService = productCardCreatorAvailabilityService;
        this.halvingPolicyAvailabilityService = halvingPolicyAvailabilityService;
        this.productInstancePreorderSettingsService = productInstancePreorderSettingsService;
        this.labelsService = labelsService;
        this.productCardCreatorPriceService = productCardCreatorPriceService;
        this.restaurant = restaurant;
        this.orderItemListTracking = orderItemListTracking;
        this.nextOrderingTime = nextOrderingTime;
        this.crossSellingAddToCartBottomSheet = crossSellingAddToCartBottomSheet;
        this.parameterScopeProvider = parameterScopeProvider;
        this.isIosReviewMode = globalConfig.isIosReviewMode;
        this.productTypes = menu.productTypes;
        makeImmutable(this);
    }
    get restaurantId() {
        return this.restaurant.id;
    }
    get nextOrderAvailableAt() {
        return this.nextOrderingTime.nextOrderAvailableAt;
    }
    getAvailability(domain) {
        return this.productCardCreatorAvailabilityService.availability(domain);
    }
    hasResult(domain) {
        return this.productCardCreatorAvailabilityService.hasResult(domain);
    }
    getResult(domain) {
        return this.productCardCreatorAvailabilityService.result(domain);
    }
    getPrice(domain) {
        return new PPrice(this.localizationProvider, this.productCardCreatorPriceService.price(domain).spectrum).priceValue;
    }
    getPriceValue(domain) {
        const price = this.productCardCreatorPriceService.price(domain).spectrum;
        switch (price.type) {
            case "value":
                return price.value.asNumber;
            case "range":
                return price.min.asNumber;
            case "null":
                return 0;
        }
    }
    labels(productInstance) {
        return this.labelsService.productCardLabels(productInstance);
    }
    getPreorderSettings(productInstance) {
        return this.productInstancePreorderSettingsService.preorderSettings(productInstance);
    }
    isSplitPossible(params) {
        if (params.isSplit) {
            return false;
        }
        else {
            return this.halvingPolicyAvailabilityService.availability(params.halvingPolicy, this.parameterScopeProvider.fromProductInstance(params.productInstance, params.fulfillmentMethod)).isAvailable.isPossible;
        }
    }
    collectCreatorData(domain, list) {
        this.orderItemListTracking.collectCreatorData(domain, list);
    }
    getProductType(productTypeString) {
        return this.productTypes.rawGet(productTypeString);
    }
};
PProductCardCreatorContext = __decorate([
    perRestaurant(),
    __param(0, inject(GlobalConfig)),
    __metadata("design:paramtypes", [typeof (_a = typeof GlobalConfig !== "undefined" && GlobalConfig) === "function" ? _a : Object, typeof (_b = typeof LocalizationProvider !== "undefined" && LocalizationProvider) === "function" ? _b : Object, typeof (_c = typeof ProductCardCreatorAvailabilityService !== "undefined" && ProductCardCreatorAvailabilityService) === "function" ? _c : Object, typeof (_d = typeof HalvingPolicyAvailabilityService !== "undefined" && HalvingPolicyAvailabilityService) === "function" ? _d : Object, typeof (_e = typeof ProductInstancePreorderSettingsService !== "undefined" && ProductInstancePreorderSettingsService) === "function" ? _e : Object, typeof (_f = typeof LabelsService !== "undefined" && LabelsService) === "function" ? _f : Object, typeof (_g = typeof ProductCardCreatorPriceService !== "undefined" && ProductCardCreatorPriceService) === "function" ? _g : Object, typeof (_h = typeof PRestaurant !== "undefined" && PRestaurant) === "function" ? _h : Object, typeof (_j = typeof Menu !== "undefined" && Menu) === "function" ? _j : Object, typeof (_k = typeof OrderItemListTracking !== "undefined" && OrderItemListTracking) === "function" ? _k : Object, typeof (_l = typeof NextOrderingTime !== "undefined" && NextOrderingTime) === "function" ? _l : Object, typeof (_m = typeof PCrossSellingAddToCartBottomSheet !== "undefined" && PCrossSellingAddToCartBottomSheet) === "function" ? _m : Object, typeof (_o = typeof ParameterScopeProvider !== "undefined" && ParameterScopeProvider) === "function" ? _o : Object])
], PProductCardCreatorContext);
export { PProductCardCreatorContext };
